/// <reference path="../../app.ts" />
namespace Cfnc {
    interface IcfncCustomerSelector extends ng.IDirective {
        restrict: string;
        replace: boolean;
        require;
        modal: ng.ui.bootstrap.IModalService;
        hideCategorySelector: boolean;
    }

    interface IcfncCustomerSelectorScope extends ng.IScope {
        open: () => void;
        onChange: (value) => (value) => void;
        ngModel: any;
        defaultCategory: string;

    }

    interface ISelectorAttributes extends ng.IAttributes {
        ngModel: string;
        defaultCategory: string;
        hideCategorySelector: boolean;
        onChange: string;
        text: string;
        cssClass: string;
    }

    class cfncCustomerSelector implements IcfncCustomerSelector {

        static directiveId: string = "cfncCustomerSelector";
        restrict: string = "E";
        replace: boolean = true;
        require = "?ngModel";
        modal: ng.ui.bootstrap.IModalService;
        hideCategorySelector: boolean;
        scope: any = {
            ngModel: "=",
            onChange: "=",
            defaultCategory: "=",
            text: "@",
            cssClass: "@"
        };

        template = "<button type='button' class='{{cssClass}}' ng-click='open()'>{{text}}</button>";


        constructor(private $uibModal: ng.ui.bootstrap.IModalService, private $timeout: ng.ITimeoutService) {

        }

        link = (scope: IcfncCustomerSelectorScope, element, attrs: ISelectorAttributes, ngModelCtrl) => {
            this.hideCategorySelector = attrs.hideCategorySelector;
            if (attrs.text == null || attrs.text == "") {
                attrs.text = "Find";
            }
            

            if (attrs.cssClass == null || attrs.cssClass == "") {
                attrs.cssClass = "btn btn-default";
            }
           

            scope.open = () => {
                var self = this;
                var modalInstance = this.$uibModal.open({
                    templateUrl: '/app/directives/cfnccustomerselector/customerSelectorModalTemplate.html',
                    controller: 'customerSelectorModal',
                    size: "lg",
                    resolve: {
                        options: function () {
                            var options = { category: scope.defaultCategory, hideCategories: self.hideCategorySelector };
                            return options;
                        }
                    },
                });
                
                modalInstance.result.then((selectedSchool) => {
                    // would normally use scope.$apply but it keeps getting $digest already in progress error
                    this.$timeout(() => {
                        scope.ngModel = selectedSchool;

                    });

                    if (scope.onChange) {
                        scope.onChange.call(scope.$parent, selectedSchool);
                        
                    }
                },() => {
                        ngModelCtrl.$setDirty();
                    });
            };
        }
    }

    angular.module("app").directive(cfncCustomerSelector.directiveId, ["$uibModal", "$timeout", ($uibModal: ng.ui.bootstrap.IModalService, $timeout: ng.ITimeoutService) =>
        new cfncCustomerSelector($uibModal, $timeout)
    ]);
}
